import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { routePathSignIn, SignIn } from './pages/unlogined/SignIn'
import { Navbar } from './Navbar'
import { notification, Result } from 'antd'
import { isAuthenticated } from './api/signIn'
import { GuardedRoute } from './GuardedRoute'
import { Donates, routePathDonates } from './pages/unlogined/Donates'
import { Cabinet, routePathCabinet } from './pages/logined/Cabinet'
import { Restore, routePathRestore } from './pages/unlogined/Restore'
import { DonateBuyError, routePathDonateBuyError } from './pages/result/DonateBuyError'
import { DonateBuySuccess, routePathDonateBuySuccess } from './pages/result/DonateBuySuccess'
import { routePathSignUpVerify, SignUpVerify } from './pages/result/SignUpVerify'
import { RestoreVerify, routePathRestoreVerify } from './pages/result/RestoreVerify'

export function App(): React.ReactElement {
	useEffect(() => {
		if (localStorage.getItem('lastver') !== '1.0.0') {
			notification.info({
				message: 'Привет, мы обновили сайт!',
				description:
					'Подробнее почитать о всех изменениях можно в нашей группе ВКонтакте (https://politcubes.com).'
			})

			localStorage.setItem('lastver', '1.0.0')
		}
	}, [])

	return (
		<BrowserRouter>
			<Navbar/>
			<Switch>
				<Route path={routePathDonateBuyError}>
					<DonateBuyError/>
				</Route>

				<Route path={routePathDonateBuySuccess}>
					<DonateBuySuccess/>
				</Route>

				<Route path={routePathRestoreVerify}>
					<RestoreVerify/>
				</Route>

				<Route path={routePathSignUpVerify}>
					<SignUpVerify/>
				</Route>

				<GuardedRoute
					path={routePathSignIn}
					redirectTo={routePathCabinet}
					exact={false}
					redirectIf={() => isAuthenticated()}
				>
					<SignIn/>
				</GuardedRoute>

				<GuardedRoute
					path={routePathCabinet}
					redirectTo={routePathSignIn}
					exact={false}
					redirectIf={() => !isAuthenticated()}
				>
					<Cabinet/>
				</GuardedRoute>

				<Route path={routePathDonates}>
					<Donates/>
				</Route>

				<Route path={routePathRestore}>
					<Restore/>
				</Route>

				<Route>
					<Result
						status={404}
						title="Упс!"
						subTitle="Данная страница не существует. Возможно, вы ошиблись адресом."
					/>
				</Route>
			</Switch>
		</BrowserRouter>
	)
}
